module.exports = __webpack_public_path__ + "img/LP---Image-Placeholder---5.0e9aaf70.png";